module.exports = __webpack_public_path__ + "static/media/sf_900_gray.1a46c2919458625e167a51461280a553.png";